export default __webpack_public_path__ + "static/media/nv1.0f574461.PNG";